import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { UGGLogoFull } from "@ugitgud/legos/ui/icon/UGGLogoFull";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import { SvgBrandIcyVeins } from "@ugitgud/legos/ui/icon/SVG/BrandIcyVeins";
import { SvgGameWowDetailed } from "@ugitgud/legos/ui/icon/SVG/GameWowDetailed";
import classNames from "classnames";
import { useCallback, useState } from "react";

export interface BannerProps {
  url: string;
  onClick: (url: string) => void;
  onClose?: () => void;
  utmSource?: string;
}

export const WOW_APP_BANNER_CTA = "wow-app-banner";

const BANNER_ART = "https://static.bigbrain.gg/assets/ugg/pages/desktop-app/wow/wow-banner.webp";

export function WoWAppBanner(props: BannerProps) {
  const { url, onClick, onClose, utmSource } = props;
  const [open, setOpen] = useState(true);

  const finalUrl = url || `https://www.icyveins.gg/app${utmSource ? `?utm_source=${utmSource}` : ""}`;

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(finalUrl);
  };

  const handleClose = useCallback(() => {
    setOpen(false);
    setTimeout(() => {
      onClose?.();
    }, 150);
  }, [onClose, setOpen]);

  return (
    <div
      className={classNames("transition-all relative px-[12px] w-full overflow-hidden bg-[#060b20]", open ? "h-[48px]" : "h-0")}
    >
      <div className="absolute right-0 top-0 h-full w-[781px] max-w-full">
        <div className="h-full w-full bg-cover bg-right bg-no-repeat" style={{ backgroundImage: `url(${BANNER_ART})` }} />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,#060b20_0%,rgba(6,11,32,0)_27%)] max-xs:bg-[linear-gradient(90deg,#060b20_0%,rgba(6,11,32,0)_65%)]" />
      </div>
      <div className="absolute bottom-0 left-0 h-px w-full bg-[#edda01]" />
      <div className="relative flex items-center justify-center gap-[18px] h-full max-xs:justify-between">
        <div className="flex items-center gap-[6px] max-xs:hidden">
          <Icon icon={<UGGLogoFull />} className="h-[26px] w-[80px]" />
          <Icon
            icon={<SvgMiscX />}
            className="h-[14px] text-[#ffffff99] drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.40)] mx-[3px]"
          />
          <SvgBrandIcyVeins className="h-[36px] w-[57px]" role="img" aria-label="Icy Veins" />
        </div>
        <div className="[text-shadow:0px_1px_0px_rgba(0,_0,_0,_0.50)] translate-y-[1px]">
          <div className="font-barlow-condensed font-bold text-[18px] text-white leading-none">THE ICY VEINS WoW APP IS HERE</div>
          <div className="font-inter font-medium text-[12px] text-white leading-[1.2] mt-[4px]">
            Class Guides, Tier Lists, Class Codex
          </div>
        </div>
        <a href={finalUrl} onClick={onUrlClick}>
          <div
            className={`flex items-center justify-center gap-[6px] px-[12px] h-[30px] rounded-[3px] whitespace-nowrap
            bg-[#0b7ba4] border border-[#ade9ff] drop-shadow-[0px_2px_1px_rgba(0,0,0,0.25)]
            font-barlow-condensed text-[13px] font-bold leading-none text-white
            cursor-pointer hover:bg-[#0d93c4]`}
          >
            <Icon icon={<SvgGameWowDetailed />} className="w-[20px] h-[20px]" />
            <span className="font-barlow-condensed">DOWNLOAD NOW</span>
          </div>
        </a>
      </div>
      {onClose && (
        <div
          className="absolute top-[50%] right-[12px] translate-y-[-50%] p-[6px] cursor-pointer hover:opacity-50 max-xs:hidden"
          onClick={handleClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="fill-white drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.50)]" />
        </div>
      )}
    </div>
  );
}
